import styled, { keyframes } from 'styled-components';
import Modal from 'react-modal';
import {
  colorGraySemiLight,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 100%;
  font-family: ${fontFamilyPrimary};
`;
export const StyledModal = styled(Modal)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  padding: 8px;
  overflow-x: hidden;
  overflow-y: auto;

  @media all and ${mediaQueryMobileLargeMin} {
    --modal-height: min(90vh, 740px);
    --image-ratio: ${({ $imageRatio = 0.943 }) => $imageRatio};
    --vertical-chrome: 190px;
    --horizontal-padding: 64px;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 90vh;
    height: min(90vh, 740px);
    padding: 18px 32px 32px;
    width: 564px;
    border-radius: 16px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.24);
    overflow-y: auto;
  }
`;
export const Title = styled.div`
  font-size: 20px;
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 21px;
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colorGraySemiLight};
  margin: 0 -8px;
  padding: 0 16px 14px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin: 0 -32px;
    padding: 0 32px 14px;
  }

  svg {
    position: relative;
    right: -8px;
  }
`;
export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow: visible;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 16px;

  img {
    display: block;
  }
`;

export const Footer = styled.div`
  margin-top: 0;
`;

const previewLoading = keyframes`
  100% {
      transform: translateX(100%);
  }
`;

export const PreviewBox = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  min-height: 0;
  width: ${({ $ratio = 0.943 }) =>
    `min(100%, calc((min(90vh, 740px) - 150px) * ${$ratio}))`};
  margin: 0 auto;
  border-radius: 8px;
  background: #f2f3f2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #1f2729;
  text-align: center;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      #f2f3f2 0%,
      #d9dbdb 20%,
      #dadbdb 60%,
      #f2f3f2
    );

    animation: ${previewLoading} 5s infinite;
    content: '';
  }

  & > div {
    position: relative;
    z-index: 1;
    font-size: 16px;
  }
`;

export const PreviewImage = styled.img`
  position: relative;
  z-index: 1;
  width: ${({ $ratio = 0.943 }) =>
    `min(100%, calc((min(90vh, 740px) - 190px) * ${$ratio}))`};
  height: auto;
  min-width: 140px;
  max-height: 100%;
  margin: 0 auto;
  object-fit: contain;
`;
